<template>
  <QuoteFormEmbeddable
      @mounted="onMountedForm"
      @beforeSubmit="onBeforeSubmit"
      @reload="reload()"
      ref="embeddable"
      v-model="form"
      v-if="!mountAgain"
      :enabled-submit="enabledSubmit"
  />
</template>
<script>
import businessQuoteFormEmbeddableMixin from "@/mixins/embeddable/business/businessQuoteFormEmbeddableMixin";
export default {
  name: 'QuoteForm',
  mixins: [businessQuoteFormEmbeddableMixin],
  data() {
    return {

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onBeforeSubmit() {

      //Libera a continuidade sem nenhuma condição especial
      this.enabledSubmit = true
    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
}
</script>
